import { render, staticRenderFns } from "./TextScroll.vue?vue&type=template&id=30704b94&scoped=true&"
import script from "./TextScroll.vue?vue&type=script&lang=ts&"
export * from "./TextScroll.vue?vue&type=script&lang=ts&"
import style0 from "./TextScroll.vue?vue&type=style&index=0&id=30704b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30704b94",
  null
  
)

export default component.exports